import * as React from 'react'
import setTheme from '../../shared/components/setTheme'
import useLocalStorage from '../../hooks/useLocalStorage'
import useCookie from '../useCookie'

const { getCookie, setCookie } = useCookie()

// trocar localstorage por cookie
export default function useTheme(initialTheme = 'mdnTheme') {
  let storageTheme = getCookie('mdnTheme');
  const theme = storageTheme || initialTheme
  const [currentTheme, setCurrentTheme] = React.useState(theme)
  const { setStorageItem, getStorageItem } = useLocalStorage()


  React.useEffect(() => {
    const data = theme

    if (data && typeof window !== 'undefined') {
      const newTheme = currentTheme === 'contrast'
        ? 'contrast'
        : initialTheme

      setTheme(newTheme)
      setStorageItem('mdnTheme', newTheme)
      setCookie('mdnTheme', newTheme, 5000)
    }

  }, [])

  function toggleTheme() {
    if (typeof window === 'undefined') return
    const newTheme = currentTheme === 'contrast'
      ? initialTheme
      : 'contrast'

    setCurrentTheme(newTheme)
    setTheme(newTheme)
    setStorageItem('mdnTheme', newTheme)
    setCookie('mdnTheme', newTheme, 5000)

  }
  return {
    initialTheme,
    currentTheme,
    toggleTheme
  }
}

export { setTheme }